var endpointMap = {
    cs: {
        "pages.app": "translation-cs.json",
        "pages.dogPage": "translation-cs.json",
        "pages.invalidAuthPage": "translation-cs.json",
        "pages.paymentSelectionPage": "translation-cs.json",
        "pages.previewOrderPage": "translation-cs.json",
        "pages.productDetails": "translation-cs.json",
        "pages.thankYouPage": "translation-cs.json"
    },
    "cs-CZ": {
        "pages.app": "translation-cs.json",
        "pages.dogPage": "translation-cs.json",
        "pages.invalidAuthPage": "translation-cs.json",
        "pages.paymentSelectionPage": "translation-cs.json",
        "pages.previewOrderPage": "translation-cs.json",
        "pages.productDetails": "translation-cs.json",
        "pages.thankYouPage": "translation-cs.json"
    },
    da: {
        "pages.app": "translation-da.json",
        "pages.dogPage": "translation-da.json",
        "pages.invalidAuthPage": "translation-da.json",
        "pages.paymentSelectionPage": "translation-da.json",
        "pages.previewOrderPage": "translation-da.json",
        "pages.productDetails": "translation-da.json",
        "pages.thankYouPage": "translation-da.json"
    },
    "da-DK": {
        "pages.app": "translation-da.json",
        "pages.dogPage": "translation-da.json",
        "pages.invalidAuthPage": "translation-da.json",
        "pages.paymentSelectionPage": "translation-da.json",
        "pages.previewOrderPage": "translation-da.json",
        "pages.productDetails": "translation-da.json",
        "pages.thankYouPage": "translation-da.json"
    },
    de: {
        "pages.app": "translation-de.json",
        "pages.dogPage": "translation-de.json",
        "pages.invalidAuthPage": "translation-de.json",
        "pages.paymentSelectionPage": "translation-de.json",
        "pages.previewOrderPage": "translation-de.json",
        "pages.productDetails": "translation-de.json",
        "pages.thankYouPage": "translation-de.json"
    },
    "de-DE": {
        "pages.app": "translation-de.json",
        "pages.dogPage": "translation-de.json",
        "pages.invalidAuthPage": "translation-de.json",
        "pages.paymentSelectionPage": "translation-de.json",
        "pages.previewOrderPage": "translation-de.json",
        "pages.productDetails": "translation-de.json",
        "pages.thankYouPage": "translation-de.json"
    },
    en: {
        "pages.app": "translation-en.json",
        "pages.dogPage": "translation-en.json",
        "pages.invalidAuthPage": "translation-en.json",
        "pages.paymentSelectionPage": "translation-en.json",
        "pages.previewOrderPage": "translation-en.json",
        "pages.productDetails": "translation-en.json",
        "pages.thankYouPage": "translation-en.json"
    },
    "en-CA": {
        "pages.app": "translation-en.json",
        "pages.dogPage": "translation-en.json",
        "pages.invalidAuthPage": "translation-en.json",
        "pages.paymentSelectionPage": "translation-en.json",
        "pages.previewOrderPage": "translation-en.json",
        "pages.productDetails": "translation-en.json",
        "pages.thankYouPage": "translation-en.json"
    },
    "en-GB": {
        "pages.app": "translation-en.json",
        "pages.dogPage": "translation-en.json",
        "pages.invalidAuthPage": "translation-en.json",
        "pages.paymentSelectionPage": "translation-en.json",
        "pages.previewOrderPage": "translation-en.json",
        "pages.productDetails": "translation-en.json",
        "pages.thankYouPage": "translation-en.json"
    },
    "en-US": {
        "pages.app": "translation-en.json",
        "pages.dogPage": "translation-en.json",
        "pages.invalidAuthPage": "translation-en.json",
        "pages.paymentSelectionPage": "translation-en.json",
        "pages.previewOrderPage": "translation-en.json",
        "pages.productDetails": "translation-en.json",
        "pages.thankYouPage": "translation-en.json"
    },
    es: {
        "pages.app": "translation-es.json",
        "pages.dogPage": "translation-es.json",
        "pages.invalidAuthPage": "translation-es.json",
        "pages.paymentSelectionPage": "translation-es.json",
        "pages.previewOrderPage": "translation-es.json",
        "pages.productDetails": "translation-es.json",
        "pages.thankYouPage": "translation-es.json"
    },
    "es-ES": {
        "pages.app": "translation-es.json",
        "pages.dogPage": "translation-es.json",
        "pages.invalidAuthPage": "translation-es.json",
        "pages.paymentSelectionPage": "translation-es.json",
        "pages.previewOrderPage": "translation-es.json",
        "pages.productDetails": "translation-es.json",
        "pages.thankYouPage": "translation-es.json"
    },
    "es-US": {
        "pages.app": "translation-es.json",
        "pages.dogPage": "translation-es.json",
        "pages.invalidAuthPage": "translation-es.json",
        "pages.paymentSelectionPage": "translation-es.json",
        "pages.previewOrderPage": "translation-es.json",
        "pages.productDetails": "translation-es.json",
        "pages.thankYouPage": "translation-es.json"
    },
    fr: {
        "pages.app": "translation-fr.json",
        "pages.dogPage": "translation-fr.json",
        "pages.invalidAuthPage": "translation-fr.json",
        "pages.paymentSelectionPage": "translation-fr.json",
        "pages.previewOrderPage": "translation-fr.json",
        "pages.productDetails": "translation-fr.json",
        "pages.thankYouPage": "translation-fr.json"
    },
    "fr-CA": {
        "pages.app": "translation-fr.json",
        "pages.dogPage": "translation-fr.json",
        "pages.invalidAuthPage": "translation-fr.json",
        "pages.paymentSelectionPage": "translation-fr.json",
        "pages.previewOrderPage": "translation-fr.json",
        "pages.productDetails": "translation-fr.json",
        "pages.thankYouPage": "translation-fr.json"
    },
    "fr-FR": {
        "pages.app": "translation-fr.json",
        "pages.dogPage": "translation-fr.json",
        "pages.invalidAuthPage": "translation-fr.json",
        "pages.paymentSelectionPage": "translation-fr.json",
        "pages.previewOrderPage": "translation-fr.json",
        "pages.productDetails": "translation-fr.json",
        "pages.thankYouPage": "translation-fr.json"
    },
    it: {
        "pages.app": "translation-it.json",
        "pages.dogPage": "translation-it.json",
        "pages.invalidAuthPage": "translation-it.json",
        "pages.paymentSelectionPage": "translation-it.json",
        "pages.previewOrderPage": "translation-it.json",
        "pages.productDetails": "translation-it.json",
        "pages.thankYouPage": "translation-it.json"
    },
    "it-IT": {
        "pages.app": "translation-it.json",
        "pages.dogPage": "translation-it.json",
        "pages.invalidAuthPage": "translation-it.json",
        "pages.paymentSelectionPage": "translation-it.json",
        "pages.previewOrderPage": "translation-it.json",
        "pages.productDetails": "translation-it.json",
        "pages.thankYouPage": "translation-it.json"
    },
    nl: {
        "pages.app": "translation-nl.json",
        "pages.dogPage": "translation-nl.json",
        "pages.invalidAuthPage": "translation-nl.json",
        "pages.paymentSelectionPage": "translation-nl.json",
        "pages.previewOrderPage": "translation-nl.json",
        "pages.productDetails": "translation-nl.json",
        "pages.thankYouPage": "translation-nl.json"
    },
    "nl-NL": {
        "pages.app": "translation-nl.json",
        "pages.dogPage": "translation-nl.json",
        "pages.invalidAuthPage": "translation-nl.json",
        "pages.paymentSelectionPage": "translation-nl.json",
        "pages.previewOrderPage": "translation-nl.json",
        "pages.productDetails": "translation-nl.json",
        "pages.thankYouPage": "translation-nl.json"
    },
    pl: {
        "pages.app": "translation-pl.json",
        "pages.dogPage": "translation-pl.json",
        "pages.invalidAuthPage": "translation-pl.json",
        "pages.paymentSelectionPage": "translation-pl.json",
        "pages.previewOrderPage": "translation-pl.json",
        "pages.productDetails": "translation-pl.json",
        "pages.thankYouPage": "translation-pl.json"
    },
    "pl-PL": {
        "pages.app": "translation-pl.json",
        "pages.dogPage": "translation-pl.json",
        "pages.invalidAuthPage": "translation-pl.json",
        "pages.paymentSelectionPage": "translation-pl.json",
        "pages.previewOrderPage": "translation-pl.json",
        "pages.productDetails": "translation-pl.json",
        "pages.thankYouPage": "translation-pl.json"
    },
    pt: {
        "pages.app": "translation-pt.json",
        "pages.dogPage": "translation-pt.json",
        "pages.invalidAuthPage": "translation-pt.json",
        "pages.paymentSelectionPage": "translation-pt.json",
        "pages.previewOrderPage": "translation-pt.json",
        "pages.productDetails": "translation-pt.json",
        "pages.thankYouPage": "translation-pt.json"
    },
    "pt-PT": {
        "pages.app": "translation-pt.json",
        "pages.dogPage": "translation-pt.json",
        "pages.invalidAuthPage": "translation-pt.json",
        "pages.paymentSelectionPage": "translation-pt.json",
        "pages.previewOrderPage": "translation-pt.json",
        "pages.productDetails": "translation-pt.json",
        "pages.thankYouPage": "translation-pt.json"
    },
    tr: {
        "pages.app": "translation-tr.json",
        "pages.dogPage": "translation-tr.json",
        "pages.invalidAuthPage": "translation-tr.json",
        "pages.paymentSelectionPage": "translation-tr.json",
        "pages.previewOrderPage": "translation-tr.json",
        "pages.productDetails": "translation-tr.json",
        "pages.thankYouPage": "translation-tr.json"
    },
    "tr-TR": {
        "pages.app": "translation-tr.json",
        "pages.dogPage": "translation-tr.json",
        "pages.invalidAuthPage": "translation-tr.json",
        "pages.paymentSelectionPage": "translation-tr.json",
        "pages.previewOrderPage": "translation-tr.json",
        "pages.productDetails": "translation-tr.json",
        "pages.thankYouPage": "translation-tr.json"
    },
    und: {
        "pages.app": "translation.json",
        "pages.dogPage": "translation.json",
        "pages.invalidAuthPage": "translation.json",
        "pages.paymentSelectionPage": "translation.json",
        "pages.previewOrderPage": "translation.json",
        "pages.productDetails": "translation.json",
        "pages.storefrontPage": "translation.json",
        "pages.thankYouPage": "translation.json"
    }
};
var arbManifest = {
    endpointMap: endpointMap
};
export { arbManifest as default, endpointMap };
